import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    marginTop: 0,
    padding: theme.spacing(1, 4, 4, 4),
    background: theme.palette.opaque.light,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ['@media(max-width:600px)']: {
      padding: theme.spacing(1, 2, 4, 2),
      background: theme.palette.bg.main,
    },
  },
  poweredByLabra: {
    marginTop: theme.spacing(4.5),
    display: 'flex',
    justifyContent: 'flex-end',
  },
  content: {
    maxWidth: '1200px',
    width: '100%',
    ['@media(max-width:1600px)']: {},
    ['@media(min-width:1600px)']: {},
    ['@media(max-width:1290px)']: {},
  },
}))
